import CircleNotificationsOutlinedIcon from "@mui/icons-material/CircleNotificationsOutlined";
import {
  Box,
  Paper,
  Popover,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useMemo, useRef } from "react";
import { AppHeaderText } from "../../../data/texts";
import { SingleNotification } from "../../../models/user.models";
import { DateTimeService } from "../../../services/date-time.service";
import StyledNotificationBubble from "../../../styled-cmps/notification-bubble";
import useScreen from "../../common/UseScreen";
import { useNavigate } from "react-router";
interface NotificationButtonProps {
  notifications: SingleNotification[];
  isOpen: boolean;
  onChange: (isOpen: boolean) => void;
  notificationCount?: number;
}

const NotificationButton = ({
  notifications,
  isOpen,
  notificationCount,
  onChange,
}: NotificationButtonProps) => {
  const notificationRef = useRef();
  const theme = useTheme();
  const { isDesktop } = useScreen();
  const navigate = useNavigate();

  const getNotificationMsg = (message: string) => {
    if (!message) {
      return;
    }
    if (message.startsWith("http")) {
      return AppHeaderText.CALL_REQUEST_AGENT;
    }
    return message;
  };

  const onNotificationClick = (notification: SingleNotification) => {
    const route =
      notification.type === "blockchain-analysis"
        ? `${notification.type}/status`
        : `product/${notification.type}`;
    navigate(route);

    onChange(false);
  };

  const showNotificationBubble = useMemo(() => {
    return Boolean(notificationCount && notificationCount > 0);
  }, [notifications]);

  return (
    <Box>
      <StyledNotificationBubble
        hasNotifications={showNotificationBubble}
        ref={notificationRef}
      >
        {notificationCount || ""}
      </StyledNotificationBubble>

      <Popover
        anchorEl={notificationRef.current}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={isOpen}
        onClose={() => onChange(false)}
        sx={{
          marginTop: "30px",
          marginInline: isDesktop ? "20px" : "0",
          width: isDesktop ? "unset" : "100%",
        }}
      >
        <Paper
          sx={{
            minWidth: isDesktop ? "300px" : "100%",
            minHeight: notifications.length ? "100px" : "60px",
          }}
        >
          {(notifications || []).length > 0 ? (
            notifications.map((notification, index) => (
              <Box
                key={`${notification.createdAt}-${index}`}
                onClick={() => {
                  onNotificationClick(notification);
                }}
                sx={{
                  ":hover": {
                    background: "#F7F7F7",
                  },
                  transition: "0.3s",
                  cursor: "pointer",
                  display: "flex",
                  padding: "15px",
                  gap: "8px",
                }}
              >
                <CircleNotificationsOutlinedIcon sx={{ fontSize: "35px" }} />
                <Stack>
                  <Typography
                    sx={{
                      width: "90%",
                      marginBottom: "5px",
                      ...theme.customStyles.ellipsisTwoLine,
                    }}
                  >
                    {getNotificationMsg(notification.message)}
                  </Typography>
                  <Typography sx={{ fontWeight: "200", fontSize: "12px" }}>
                    {DateTimeService.convertDateToDDMMYYYY(
                      new Date(notification.createdAt)
                    )}
                  </Typography>
                </Stack>
              </Box>
            ))
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                textAlign: "center",
                padding: "40px",
              }}
            >
              <Typography sx={{ fontSize: "13px", color: "#A0A0A0" }}>
                No new notifications
              </Typography>
            </Box>
          )}
        </Paper>
      </Popover>
    </Box>
  );
};

export default NotificationButton;
